import { createApp } from 'vue';
import '../../participation/assets/js/vendor/intl-tel-input/css/intlTelInput.min.css';
import '../../participation/assets/js/vendor/intl-tel-input/js/intlTelInput.min.js';
import App from './App.vue';
import './styles.css';

createApp(App).mount('#app');
